import { CONVERSION_FAMILIES, fromStorageValue } from './fieldConversions'

// Une configuration invalide laisse les événements dans leur format d'origine.
export function normalizeTimelineConversion(config) {
  if (!config || config.enabled !== true) return null
  const family = CONVERSION_FAMILIES.find(item => item.value === config.family)
  if (!family) return null
  const storage = family.units.find(unit => unit.value === config.storageUnit)
  const display = family.units.find(unit => unit.value === config.displayUnit)
  if (!storage || !display) return null
  const decimals = Number(config.decimals)
  const fields = Array.isArray(config.fields) ? config.fields.filter(field => typeof field === 'string').map(field => field.trim().replace(/\s+/g, '.')).filter(field => {
    const parts = field.split('.')
    return parts.every(part => part && !['__proto__', 'constructor', 'prototype'].includes(part))
  }) : []
  return {
    family: family.value, storageUnit: storage.value, displayUnit: display.value,
    decimals: Number.isInteger(decimals) && decimals >= 0 && decimals <= 6 ? decimals : 2,
    symbol: display.symbol, fields: [...new Set(fields)],
  }
}

// Le calcul exact partagé produit uniquement un texte, jamais une nouvelle quantité.
function displayValue(value, config) {
  const result = fromStorageValue(value, {
    family: config.family, storageUnit: config.storageUnit,
    defaultUnit: config.displayUnit, decimals: config.decimals,
  }, config.displayUnit)
  if (!result.valid || result.display === '') return '—'
  const [integer, fraction] = result.display.split(',')
  return integer.replace(/\B(?=(\d{3})+(?!\d))/g, '\u202f') + (fraction === undefined ? '' : `,${fraction}`)
}

// Copie uniquement les branches enrichies, sans écraser les données du fournisseur.
export function timelineDisplayLine(event, settings) {
  const config = normalizeTimelineConversion(settings)
  if (!config || !event || typeof event !== 'object') return event
  const line = { ...event }
  if (!Object.prototype.hasOwnProperty.call(line, 'display_unit')) line.display_unit = config.symbol
  config.fields.forEach(field => {
    const parts = field.split('.')
    const key = parts.pop()
    let source = event
    for (const part of parts) {
      if (!source || !Object.prototype.hasOwnProperty.call(source, part)) return
      source = source[part]
    }
    if (!source || typeof source !== 'object' || !Object.prototype.hasOwnProperty.call(source, key)) return
    const alias = `${key}_display`
    if (Object.prototype.hasOwnProperty.call(source, alias)) return
    let destination = line
    parts.forEach(part => {
      destination[part] = Array.isArray(destination[part]) ? [...destination[part]] : { ...destination[part] }
      destination = destination[part]
    })
    destination[alias] = displayValue(source[key], config)
  })
  return line
}

// Le rond sans visuel conserve sa priorité historique et convertit sa seule source.
export function timelineMiddleFallback(event, settings) {
  const key = event.middle_value !== undefined ? 'middle_value' : (event.stock_after !== undefined ? 'stock_after' : 'quantity')
  const value = event[key]
  if (value === undefined || value === null) return ''
  const config = normalizeTimelineConversion(settings)
  return config && config.fields.includes(key) ? displayValue(value, config) : value
}
